
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWarningSilencedOutlined as ObiWarningSilencedOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-warning-silenced-outlined.js';
 
 
 

 
 export const ObiWarningSilencedOutlined = createComponent({
   react: React,
   tagName: 'obi-warning-silenced-outlined',
   elementClass: ObiWarningSilencedOutlinedElement,
   events: {
     
   }
  });
 
 